$(function () {
    const body = $('body');
    const nav = $('.nav');
    const burger = $('.burger');
    const nav_trigger = $('.nav').find('ul li.menu-item-has-children .expand-button, ul li.menu-item-has-children .menu-item-link > a');
    const megamenu_trigger = $('.nav').find('ul li.menu-item-has-megamenu .menu-item-has-megamenu-button .expand-button, ul li.menu-item-has-megamenu .menu-item-has-megamenu-button>a');
    const megamenu_child_trigger = $('.nav').find('ul li.menu-item-has-megamenu a.megamenu-link-has-children');
    const break_point = 992;
    const nav_window = $('<div class="navwindow"></div>');
    body.append(nav_window);
    const nav_wrap = $('.navwrap');

    const wrapper = $('header.header');
    const searchToggle = $('.searchToggleTrigger');

    document.addEventListener('keydown', function (event) {
        const key = event.key;
        if (key === "Escape") {
            if (window.innerWidth < break_point) {
                nav_reset();
                burger.focus();
            } else {
                $('.menu-item-has-children').removeClass('__active');
                $('.menu-item-has-megamenu').removeClass('__active');
                $('.menu-item-has-megamenu button').attr('aria-expanded', false);
                body.removeClass('__blur');
            }
        }
    });

    nav_window.click(function (event) {
        nav_reset();
    });

    //burger click
    burger.click(function (event) {
        event.preventDefault();
        $(this).toggleClass('__active');
        if (body.hasClass('__mobile')) {
            nav_reset();
        } else {
            nav_launch();
        }
    });

    /*nav reset*/
    const nav_reset = function nav_reset() {
        burger.removeClass('__active');
        nav_window.hide();
        body.removeClass('__mobile');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul, div').removeClass('__active');
        body.removeClass('__blur');
    };

    /*nav launch*/
    const nav_launch = function nav_launch() {
        nav_window.show();
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
        wrapper.removeClass('__searchactive');
        searchToggle.removeClass('__active');
    };

    
    function initMenu() {
        const browser_width = window.innerWidth;

        nav_trigger.off('.menu');
        megamenu_trigger.off('.menu');
        megamenu_child_trigger.off('.menu');
        $('.backto').off('.menu');
        $('.backto button').off('.menu');
        $('.viewall').off('.menu');
        $('.menu-item-has-children .menu-item-link > a, .menu-item-has-megamenu .menu-item-has-megamenu-button> a, a.megamenu-link-has-children').off('.menu');
        $(document).off('click.menu');
        $('.navwrap ul').off('.menu');

        $( ".navwrap ul").on( "mouseenter.menu focusin.menu", function() {
            $('.navwrap ul').each(function () {
                const elem = $(this)
                const rect = elem[0].getBoundingClientRect();
                if(rect.x + rect.width > window.innerWidth) {
                    $(this).addClass('left');
                }
            });
        });

         // nav dropdown on focus/keyboard navigation
        if (browser_width >= break_point) {
            nav.find('a, button').removeAttr('tabindex');

            nav_trigger.on('click.menu', function (event) {
                if($(this).is('button')) {
                    event.preventDefault();
                    $(this).closest('li.menu-item-has-children').siblings().removeClass('__active');
                    $(this).closest('li.menu-item-has-children').siblings().find('.__active').removeClass('__active');
                    $(this).closest('li.menu-item-has-children').siblings().find('[aria-expanded="true"]').attr('aria-expanded', false);
                    $(this).closest('li.menu-item-has-children').toggleClass('__active');
                    if($(this).closest('li.menu-item-has-children').hasClass( '__active' )) {
                        $(this).attr('aria-expanded', true);
                    } else {
                        $(this).attr('aria-expanded', false);
                        $(this).closest('li.menu-item-has-children').find('.__active').removeClass('__active');
                    }
                }
            });
            megamenu_trigger.on('click.menu', function (event) {
                if($(this).is('button')) {
                    event.preventDefault();
                    body.toggleClass('__blur');
                    $(this).parent().parent().siblings().removeClass('__active');
                    $(this).parent().parent().siblings().find('.__active').removeClass('__active');
                    $(this).parent().parent().siblings().find('[aria-expanded="true"]').attr('aria-expanded', false);
                    $(this).parent().parent().toggleClass('__active');
                    if($(this).parent().parent().hasClass( '__active' )) {
                        $(this).attr('aria-expanded', true);
                    } else {
                        $(this).attr('aria-expanded', false);
                        $(this).parent().parent().find('.__active').removeClass('__active');
                    }
                }
            });

            $(document).on("click.menu", function (event) {
                if ($(event.target).closest(".nav[aria-label='Primary']").length === 0) {
                    nav.find('.__active').removeClass('__active');
                    nav.find('[aria-expanded="true"]').attr('aria-expanded', false);
                    body.removeClass('__blur');
                }
            });
        }

        if (browser_width < break_point) {
            nav_trigger.on('click.menu', function (event) {
                event.stopPropagation();
                if ($(this).closest('li.menu-item-has-children').children('ul').length > 0) {
                    $(this)
                        .closest('li.menu-item-has-children').children('ul')
                        .addClass('__active');
                    $(this)
                        .closest('li.menu-item-has-children').children('ul').find('li:first-child a, li:first-child button').focus();
                }
            });

            megamenu_trigger.on('click.menu', function (event) {
                event.stopPropagation();

                $(this)
                    .parent().parent()
                    .toggleClass('__active');
                $(this)
                    .parent().parent()
                    .children('.menu-item-is-megamenu')
                    .toggleClass('__active');
                $(this)
                        .parent().siblings('.menu-item-is-megamenu').find('>div:first-child a, >div:first-child button').focus();
            });

            megamenu_child_trigger.on('click.menu', function (event) {
                $(this)
                    .toggleClass('__active');
                $(this)
                    .siblings('.megamenu-list')
                    .toggleClass('__active');
            });

            // Disable root item link click
            $('.menu-item-has-children .menu-item-link > a, .menu-item-has-megamenu .menu-item-has-megamenu-button> a, a.megamenu-link-has-children').on('click.menu', function (event) {
                event.preventDefault();
            });
        }

        if (browser_width < break_point) {

            nav.find('a, button').attr('tabindex', '-1');
            const back_menu = $('.backto');
            back_menu.on('click.menu', function (event) {
                event.preventDefault();
                event.stopPropagation();
                $(this)
                    .parent('ul, .menu-item-is-megamenu')
                    .removeClass('__active');
                $(this)
                    .parents('li')
                    .parent('ul')
                    .addClass('__active');
                $(this)
                    .parents('li').children('.menu-item-link').children('a').focus();
            });

        } else {
            nav_reset();
        }
        

        // Touch device check
        const isTouchDevice = () => {
            return globalThis.matchMedia("(pointer: coarse)").matches
        }

        // Create view button for touchscreen devices
        const view_button = $('<li class="viewall"><a href="#">View</a></li>');
        
        // If desktop and touch device, disable link click and add extra view link
        if (browser_width >= break_point && isTouchDevice()) {
            nav_trigger.on('click.menu', function (event) {
                event.stopPropagation();
                if ($(this).closest('li.menu-item-has-children').children('ul').length > 0) {
                    event.preventDefault();
                }
            });

            nav_ul.prepend(view_button);
        }

        const view_all = $('.viewall');
        view_all.on('click.menu', function (event) {
            event.stopPropagation();
        });

        const back_menu = $('.backto button');
        back_menu.on('click.menu', function (event) {
            event.preventDefault();
            event.stopPropagation();
            $(this).closest('.__active').removeClass('__active');
            if($(this).parent().parent().hasClass("menu-item-is-megamenu")) {
                body.removeClass('__blur');
            }
        });
    }
    
    initMenu();

    let previousMode = window.innerWidth >= break_point
        ? 'desktop'
        : 'mobile';

    let resizeTimer;

    $(globalThis).on('resize', function () {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function () {
            const currentMode = window.innerWidth >= break_point
                ? 'desktop'
                : 'mobile';

            if (currentMode !== previousMode) {
                previousMode = currentMode;
                initMenu();
            }
        }, 250);
    });

});